export const PURCHASE_ORDER_PRINT_STYLES = `
  .po-print-root * { box-sizing: border-box; }
  .po-print-root {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 11pt;
    color: #1f2937;
    line-height: 1.5;
    background: white;
  }
  .po-print-root .print-container {
    background: white;
    padding: 10mm 8mm;
    width: 210mm;
    min-height: auto;
  }
  .po-print-root .header {
    text-align: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 2px solid #0d9488;
  }
  .po-print-root .header h1 {
    font-size: 18pt;
    font-weight: bold;
    color: #0d9488;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .po-print-root .info-compact {
    margin-bottom: 12px;
    font-size: 10pt;
    line-height: 1.5;
    color: #374151;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .po-print-root .info-compact-line { margin-bottom: 0; }
  .po-print-root .info-compact-label { font-weight: 600; color: #0d9488; }
  .po-print-root .info-compact-sep { color: #9ca3af; }
  .po-print-root .status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 8pt;
    font-weight: 600;
    text-transform: uppercase;
  }
  .po-print-root .items-card {
    margin-top: 8px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 10px;
  }
  .po-print-root .items-title {
    font-weight: 700;
    font-size: 11pt;
    color: #0d9488;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 2px solid #0d9488;
    text-transform: uppercase;
  }
  .po-print-root .items-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 8pt;
    table-layout: fixed;
  }
  .po-print-root .items-table thead { background: #0d9488; color: white; }
  .po-print-root .items-table th {
    padding: 7px 5px;
    text-align: left;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 7pt;
    border: 1px solid #0d9488;
  }
  .po-print-root .items-table td {
    padding: 7px 5px;
    border: 1px solid #e5e7eb;
    background: white;
    vertical-align: top;
  }
  .po-print-root .items-table tbody tr:nth-child(even) td { background: #f9fafb; }
  .po-print-root .items-table th.num,
  .po-print-root .items-table td.num { text-align: right; }
  .po-print-root .items-table th:nth-child(1),
  .po-print-root .items-table td:nth-child(1) { width: 32%; }
  .po-print-root .items-table th:nth-child(2),
  .po-print-root .items-table td:nth-child(2) { width: 8%; text-align: center; }
  .po-print-root .items-table th:nth-child(3),
  .po-print-root .items-table td:nth-child(3) { width: 18%; }
  .po-print-root .items-table th:nth-child(4),
  .po-print-root .items-table td:nth-child(4) { width: 10%; }
  .po-print-root .items-table th:nth-child(5),
  .po-print-root .items-table td:nth-child(5) { width: 14%; }
  .po-print-root .items-table th:nth-child(6),
  .po-print-root .items-table td:nth-child(6) { width: 18%; }
  .po-print-root .product-name { font-weight: 600; color: #1f2937; }
  .po-print-root .print-footer-compact {
    margin-top: 12px;
    width: 100%;
    font-size: 9pt;
  }
  .po-print-root .print-footer-obs {
    min-width: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 4px 0;
  }
  .po-print-root .print-obs-label { font-weight: 600; color: #0d9488; }
  .po-print-root .print-obs-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    line-height: 1.3;
    color: #374151;
  }
  .po-print-root .footer-totals-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-top: 8px;
  }
  .po-print-root .footer-totals-table .col-desc { width: 32%; }
  .po-print-root .footer-totals-table .col-unit { width: 8%; }
  .po-print-root .footer-totals-table .col-project { width: 18%; }
  .po-print-root .footer-totals-table .col-qty { width: 10%; }
  .po-print-root .footer-totals-table .col-price { width: 14%; }
  .po-print-root .footer-totals-table .col-subtotal { width: 18%; }
  .po-print-root .footer-totals-table td {
    padding: 2px 5px;
    vertical-align: top;
    border: none;
  }
  .po-print-root .footer-totals-label {
    text-align: right;
    font-weight: 600;
    color: #0d9488;
    padding-right: 10px;
  }
  .po-print-root .footer-totals-label-final { font-size: 9.5pt; }
  .po-print-root .footer-totals-label-words { font-size: 8pt; }
  .po-print-root .footer-totals-amount {
    text-align: right;
    color: #6b7280;
    font-size: 8pt;
  }
  .po-print-root .footer-totals-amount-final {
    font-weight: 700;
    color: #0d9488;
    font-size: 9pt;
  }
  .po-print-root .footer-totals-amount-words {
    font-style: italic;
    font-size: 7.5pt;
    line-height: 1.3;
  }
`;

export const PURCHASE_ORDER_PRINT_PAGE_STYLES = `
  @page { size: A4; margin: 10mm 8mm; }
  @media print {
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    body { margin: 0; padding: 0; background: white; }
    .no-print { display: none !important; }
    .po-print-root .print-container { padding: 0; margin: 0; max-width: 100%; box-shadow: none; width: 100%; }
  }
  @media screen {
    body { background: #f3f4f6; }
    .po-print-root .print-container {
      max-width: 210mm;
      margin: 20px auto;
      background: white;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
    .print-actions { position: fixed; top: 20px; right: 20px; z-index: 1000; display: flex; gap: 10px; }
  }
  @media print {
    .po-print-root .print-footer-compact,
    .po-print-root .items-card { page-break-inside: avoid; }
  }
`;
